export default {
  ADD_USER_INFO: "ADD_USER_INFO",
  DELETE_USER_INFO: "DELETE_USER_INFO",
  ADD_ADMIN_LIST: "ADD_ADMIN_LIST"
};
